import { jsxs as p, jsx as t } from "react/jsx-runtime";
import { memo as R, useCallback as u } from "react";
import { Col as d, Row as b } from "antd";
import { u as o } from "./styled-components.browser.esm-3eb04950.js";
import { IconContainer as k } from "./IconContainer.js";
import w from "./valueDescription/ValueDescription.js";
import { useLanguageResolver as L } from "@biron-data/react-contexts";
import { AdditionalDetailWrapper as A, AdditionalDetailField as j } from "./additionalDetail/AdditionalDetail.js";
const M = R(function({
  icon: s,
  label: i,
  description: m,
  additionalDetails: f = [],
  itemColumnWidth: a = 4,
  children: x,
  display: c = "inline",
  layout: r = "span",
  containerStyle: C = {
    paddingTop: 15,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10
  }
}) {
  const l = L(), h = u((e, g) => e === "span" ? {
    span: g
  } : {
    flex: "none"
  }, [r, c, a]), $ = u((e, g, v, S) => e === "span" ? {
    span: S && v ? 24 - g : 24
  } : {
    flex: "auto"
  }, [r, c, a, i, s]);
  return /* @__PURE__ */ p(W, { $customStyle: C, children: [
    /* @__PURE__ */ p(F, { wrap: !1, gutter: r === "flex" ? 16 : 0, children: [
      s && i && /* @__PURE__ */ t(K, { ...h(r, a), children: /* @__PURE__ */ p(y, { gutter: 10, wrap: !1, children: [
        /* @__PURE__ */ t(d, { ...h(r, 5), children: /* @__PURE__ */ t(k, { children: /* @__PURE__ */ t(s, {}) }) }),
        /* @__PURE__ */ p(T, { span: 15, children: [
          l.get(i),
          /* @__PURE__ */ t(D, { children: m && /* @__PURE__ */ t(w, { title: l.get(i), description: l.get(m) }) })
        ] })
      ] }) }),
      /* @__PURE__ */ p(d, { ...$(r, a, i, s), children: [
        c === "inline" && x,
        f.length > 0 && /* @__PURE__ */ t(B, { children: f.map(
          (e) => /* @__PURE__ */ t(A, { additionalDetail: e, children: /* @__PURE__ */ t(j, { additionalDetail: e }) }, e.textKey)
        ) })
      ] }),
      /* @__PURE__ */ t(d, { span: 1 })
    ] }),
    c === "block" && /* @__PURE__ */ t(P, { children: x })
  ] });
}), y = o(b)`
`, B = o.div`
    margin-top: 8px;
`, P = o.div`
    margin-top: 2px;
`, D = o.div`
    padding-left: 10px;
`, T = o(d)`
    display: flex;
    justify-content: start;
    align-items: center;
    line-height: 20px; /* 142.857% */
`, W = o.div`
    padding-top: ${(n) => n.$customStyle.paddingTop}px;
    padding-right: ${(n) => n.$customStyle.paddingRight}px;
    padding-bottom: ${(n) => n.$customStyle.paddingBottom}px;
    padding-left: ${(n) => n.$customStyle.paddingLeft}px;
    border-bottom: 1px solid var(--main-background-color);
    border-top: 1px solid var(--main-background-color);

    &:not(:first-child) {
        border-top: none;
    }

    &:first-child {
        border-top: none;
        padding-top: 0;
    }

    &:last-child {
        padding-bottom: 0;
        border-bottom: none;
    }
`, F = o(b)`

`, K = o(d)`
    text-align: start;
`;
export {
  M as default
};
//# sourceMappingURL=WrapperRoot.js.map
